import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  matchPath,
} from "react-router-dom";
import { Suspense } from "react";
import React, { useState, useEffect } from "react";
import "typeface-yanone-kaffeesatz";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import ProfilePage from "./pages/ProfilePage";
import OfferProperty from "./pages/OfferProperty";
import SearchProperty from "./pages/SearchProperty";
import Login from "./pages/auth/login";
import OTPVerification from "./pages/auth/OTPVerification";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ChangePassword from "./pages/auth/ChangePassword";
import ResetPassword from "./pages/auth/ResetPassword";
import MySearch from "./pages/MySearch";
import MyMatchings from "./pages/MyMatchings";
import MyProperties from "./pages/MyProperties";
import EditOrView from "./pages/EditORView";
import SubscriptionPage from "./pages/SubscriptionPage";
import SuccessPage from "./pages/SuccessPage";
import BookmarksPage from "./pages/BookmarksPage";
import CheckoutSummaryPage from "./pages/CheckoutSummaryPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { FlowProvider } from "./context/FlowContext";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import QAPage from "./pages/QAPage";
import Support from "./pages/support";
import SearchView from "./pages/SearchView";
import PendingPropertyView from "./pages/PendingPropertyView";
import SearchPropertyView from "./pages/SearchPropertyView";
import "./App.css";
import "./utils/GoogleMapsFix.css";
import useZoomHandler from "./utils/useZoomHandler";

const SubscriptionRequiredRoute = ({ children }) => {
  const { currentUser, isAuthenticated } = useAuth();
  const location = useLocation();

  const allowedPaths = [
    "/ProfilePage",
    "/about",
    "/auth/login",
    "/subscription",
    "/checkout-summary",
    "/success",
    "/terms",
    "/privacy",
    "/qa",
    "/support",
  ];

  const isRestrictedUser =
    isAuthenticated &&
    currentUser?.userType === "offer" &&
    currentUser?.isSubscribed === false;

  const isPathAllowed = allowedPaths.some((path) =>
    matchPath(path, location.pathname)
  );
  console.log("Restricted User Check:", {
    isRestrictedUser,
    currentUser,
    isAuthenticated,
    location: location.pathname,
    isPathAllowed,
    currentUser,
  });
  if (isRestrictedUser && !isPathAllowed) {
    return <Navigate to="/subscription" replace />;
  }

  return children;
};

function App() {
  useZoomHandler();
  //  useEffect(() => {
  //       const applyZoom = () => {
  //         const screenWidth = window.innerWidth;

  //         if (screenWidth >= 1024 && screenWidth <= 1600) {
  //           // small laptop screens (12–15.6 inch, usually ≤ 1600px wide)
  //           document.body.style.zoom = "80%";
  //         } else {
  //           // larger monitors / iMacs
  //           document.body.style.zoom = "100%";
  //         }
  //       };

  //       applyZoom(); // run on load
  //       window.addEventListener("resize", applyZoom); // re-run on resize

  //       return () => window.removeEventListener("resize", applyZoom);
  //     }, []);
  const [hideFooter, setHideFooter] = useState(false);
  const [hideNavbar, setHideNavbar] = useState(false);

  return (
    <>
      <Suspense fallback={<div>Loading translations...</div>}>
        <div>
          <div className="app-container">
            {!hideNavbar && <Navbar />}
            <div style={{ flex: 1 }}>
              <Routes>
                <Route
                  path="/"
                  element={
                    <SubscriptionRequiredRoute>
                      <Home
                        setHideFooter={setHideFooter}
                        setHideNavbar={setHideNavbar}
                      />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/about"
                  element={
                    <SubscriptionRequiredRoute>
                      <About />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/ProfilePage"
                  element={
                    <SubscriptionRequiredRoute>
                      <ProfilePage />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/auth/login"
                  element={
                    <SubscriptionRequiredRoute>
                      <Login setHideFooter={setHideFooter} />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/auth/otp-verification"
                  element={
                    <SubscriptionRequiredRoute>
                      <OTPVerification setHideFooter={setHideFooter} />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/auth/forgot-password"
                  element={
                    <SubscriptionRequiredRoute>
                      <ForgotPassword setHideFooter={setHideFooter} />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/auth/change-password"
                  element={
                    <SubscriptionRequiredRoute>
                      <ChangePassword setHideFooter={setHideFooter} />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/reset-password"
                  element={<ResetPassword setHideFooter={setHideFooter} />}
                />
                <Route
                  path="/subscription"
                  element={
                    <SubscriptionRequiredRoute>
                      <SubscriptionPage />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/checkout-summary"
                  element={
                    <SubscriptionRequiredRoute>
                      <CheckoutSummaryPage />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/success"
                  element={
                    <SubscriptionRequiredRoute>
                      <SuccessPage />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/qa" element={<QAPage />} />
                <Route
                  path="/support"
                  element={
                    <SubscriptionRequiredRoute>
                      <Support />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/searchView/:id"
                  element={
                    <SubscriptionRequiredRoute>
                      <SearchView />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/BookmarksPage"
                  element={
                    <SubscriptionRequiredRoute>
                      <BookmarksPage />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/OfferProperty"
                  element={
                    <SubscriptionRequiredRoute>
                      <OfferProperty />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/SearchProperty"
                  element={
                    <SubscriptionRequiredRoute>
                      <SearchProperty />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/PendingPropertyView/:Id"
                  element={
                    <SubscriptionRequiredRoute>
                      <PendingPropertyView />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/SearchPropertyView/:id"
                  element={
                    <SubscriptionRequiredRoute>
                      <SearchPropertyView />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/MySearch"
                  element={
                    <SubscriptionRequiredRoute>
                      <MySearch />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/SearchProperty/:id"
                  element={
                    <SubscriptionRequiredRoute>
                      <SearchProperty />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/MyMatchings"
                  element={
                    <SubscriptionRequiredRoute>
                      <MyMatchings />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/MyProperties"
                  element={
                    <SubscriptionRequiredRoute>
                      <MyProperties />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/EditOrView/:id"
                  element={
                    <SubscriptionRequiredRoute>
                      <EditOrView />
                    </SubscriptionRequiredRoute>
                  }
                />
                <Route
                  path="/OfferProperty/:id"
                  element={
                    <SubscriptionRequiredRoute>
                      <OfferProperty />
                    </SubscriptionRequiredRoute>
                  }
                />
              </Routes>
            </div>
            {!hideFooter && <Footer />}
          </div>
        </div>
      </Suspense>
    </>
  );
}

export default App;
